module.exports = __webpack_public_path__ + "img/colombia.67286574.svg";